import { useQuery } from '@tanstack/react-query';
import { API } from 'network/api';
import { Season } from 'types/common';

const useSeasonByIdQuery = (seasonId?: string) => {
  const query = useQuery<Season>({
    queryKey: ['season-by-id', seasonId],
    queryFn: async () => {
      const response = await API.get(`/season/${seasonId}`);
      return response?.data;
    },
    enabled: !!seasonId,
    staleTime: 1000 * 10, // 10 seconds
  });

  return query;
};

export default useSeasonByIdQuery;
